"use strict";

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMethod = exports.create = exports.EvmDataTypeFactory = exports.Method = exports.Array = exports.Tuple = exports.Pointer = exports.String = exports.DynamicBytes = exports.StaticBytes = exports.UInt = exports.Int = exports.Bool = exports.Address = void 0;

var _ = require("lodash");

var signature_parser_1 = require("./utils/signature_parser");

var address_1 = require("./evm_data_types/address");

var array_1 = require("./evm_data_types/array");

var bool_1 = require("./evm_data_types/bool");

var dynamic_bytes_1 = require("./evm_data_types/dynamic_bytes");

var int_1 = require("./evm_data_types/int");

var method_1 = require("./evm_data_types/method");

var pointer_1 = require("./evm_data_types/pointer");

var static_bytes_1 = require("./evm_data_types/static_bytes");

var string_1 = require("./evm_data_types/string");

var tuple_1 = require("./evm_data_types/tuple");

var uint_1 = require("./evm_data_types/uint");

var Address = /*#__PURE__*/function (_address_1$AddressDat) {
  _inherits(Address, _address_1$AddressDat);

  var _super = _createSuper(Address);

  function Address(dataItem) {
    _classCallCheck(this, Address);

    return _super.call(this, dataItem, EvmDataTypeFactory.getInstance());
  }

  return Address;
}(address_1.AddressDataType);

exports.Address = Address;

var Bool = /*#__PURE__*/function (_bool_1$BoolDataType) {
  _inherits(Bool, _bool_1$BoolDataType);

  var _super2 = _createSuper(Bool);

  function Bool(dataItem) {
    _classCallCheck(this, Bool);

    return _super2.call(this, dataItem, EvmDataTypeFactory.getInstance());
  }

  return Bool;
}(bool_1.BoolDataType);

exports.Bool = Bool;

var Int = /*#__PURE__*/function (_int_1$IntDataType) {
  _inherits(Int, _int_1$IntDataType);

  var _super3 = _createSuper(Int);

  function Int(dataItem) {
    _classCallCheck(this, Int);

    return _super3.call(this, dataItem, EvmDataTypeFactory.getInstance());
  }

  return Int;
}(int_1.IntDataType);

exports.Int = Int;

var UInt = /*#__PURE__*/function (_uint_1$UIntDataType) {
  _inherits(UInt, _uint_1$UIntDataType);

  var _super4 = _createSuper(UInt);

  function UInt(dataItem) {
    _classCallCheck(this, UInt);

    return _super4.call(this, dataItem, EvmDataTypeFactory.getInstance());
  }

  return UInt;
}(uint_1.UIntDataType);

exports.UInt = UInt;

var StaticBytes = /*#__PURE__*/function (_static_bytes_1$Stati) {
  _inherits(StaticBytes, _static_bytes_1$Stati);

  var _super5 = _createSuper(StaticBytes);

  function StaticBytes(dataItem) {
    _classCallCheck(this, StaticBytes);

    return _super5.call(this, dataItem, EvmDataTypeFactory.getInstance());
  }

  return StaticBytes;
}(static_bytes_1.StaticBytesDataType);

exports.StaticBytes = StaticBytes;

var DynamicBytes = /*#__PURE__*/function (_dynamic_bytes_1$Dyna) {
  _inherits(DynamicBytes, _dynamic_bytes_1$Dyna);

  var _super6 = _createSuper(DynamicBytes);

  function DynamicBytes(dataItem) {
    _classCallCheck(this, DynamicBytes);

    return _super6.call(this, dataItem, EvmDataTypeFactory.getInstance());
  }

  return DynamicBytes;
}(dynamic_bytes_1.DynamicBytesDataType);

exports.DynamicBytes = DynamicBytes;

var String = /*#__PURE__*/function (_string_1$StringDataT) {
  _inherits(String, _string_1$StringDataT);

  var _super7 = _createSuper(String);

  function String(dataItem) {
    _classCallCheck(this, String);

    return _super7.call(this, dataItem, EvmDataTypeFactory.getInstance());
  }

  return String;
}(string_1.StringDataType);

exports.String = String;

var Pointer = /*#__PURE__*/function (_pointer_1$PointerDat) {
  _inherits(Pointer, _pointer_1$PointerDat);

  var _super8 = _createSuper(Pointer);

  function Pointer(destDataType, parentDataType) {
    _classCallCheck(this, Pointer);

    return _super8.call(this, destDataType, parentDataType, EvmDataTypeFactory.getInstance());
  }

  return Pointer;
}(pointer_1.PointerDataType);

exports.Pointer = Pointer;

var Tuple = /*#__PURE__*/function (_tuple_1$TupleDataTyp) {
  _inherits(Tuple, _tuple_1$TupleDataTyp);

  var _super9 = _createSuper(Tuple);

  function Tuple(dataItem) {
    _classCallCheck(this, Tuple);

    return _super9.call(this, dataItem, EvmDataTypeFactory.getInstance());
  }

  return Tuple;
}(tuple_1.TupleDataType);

exports.Tuple = Tuple;

var Array = /*#__PURE__*/function (_array_1$ArrayDataTyp) {
  _inherits(Array, _array_1$ArrayDataTyp);

  var _super10 = _createSuper(Array);

  function Array(dataItem) {
    _classCallCheck(this, Array);

    return _super10.call(this, dataItem, EvmDataTypeFactory.getInstance());
  }

  return Array;
}(array_1.ArrayDataType);

exports.Array = Array;

var Method = /*#__PURE__*/function (_method_1$MethodDataT) {
  _inherits(Method, _method_1$MethodDataT);

  var _super11 = _createSuper(Method);

  function Method(abi) {
    _classCallCheck(this, Method);

    return _super11.call(this, abi, EvmDataTypeFactory.getInstance());
  }

  return Method;
}(method_1.MethodDataType);

exports.Method = Method;
/* tslint:disable no-construct */

var EvmDataTypeFactory = /*#__PURE__*/function () {
  /* tslint:enable prefer-function-over-method */
  function EvmDataTypeFactory() {
    _classCallCheck(this, EvmDataTypeFactory);
  }

  _createClass(EvmDataTypeFactory, [{
    key: "create",

    /* tslint:disable prefer-function-over-method */
    value: function create(dataItem, parentDataType) {
      // Create data type
      var dataType;

      if (Array.matchType(dataItem.type)) {
        dataType = new Array(dataItem);
      } else if (Address.matchType(dataItem.type)) {
        dataType = new Address(dataItem);
      } else if (Bool.matchType(dataItem.type)) {
        dataType = new Bool(dataItem);
      } else if (Int.matchType(dataItem.type)) {
        dataType = new Int(dataItem);
      } else if (UInt.matchType(dataItem.type)) {
        dataType = new UInt(dataItem);
      } else if (StaticBytes.matchType(dataItem.type)) {
        dataType = new StaticBytes(dataItem);
      } else if (Tuple.matchType(dataItem.type)) {
        dataType = new Tuple(dataItem);
      } else if (DynamicBytes.matchType(dataItem.type)) {
        dataType = new DynamicBytes(dataItem);
      } else if (String.matchType(dataItem.type)) {
        dataType = new String(dataItem);
      } // @TODO: DataTypeement Fixed/UFixed types


      if (dataType === undefined) {
        throw new Error("Unrecognized data type: '".concat(dataItem.type, "'"));
      } else if (parentDataType !== undefined && !dataType.isStatic()) {
        var pointerToDataType = new Pointer(dataType, parentDataType);
        return pointerToDataType;
      }

      return dataType;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!EvmDataTypeFactory._instance) {
        EvmDataTypeFactory._instance = new EvmDataTypeFactory();
      }

      return EvmDataTypeFactory._instance;
    }
  }]);

  return EvmDataTypeFactory;
}();

exports.EvmDataTypeFactory = EvmDataTypeFactory;
/**
 * Convenience function for creating a DataType from different inputs.
 * @param input A single or set of DataItem or a signature for an EVM data type.
 * @return DataType corresponding to input.
 */

function create(input) {
  var dataItem = consolidateDataItemsIntoSingle(input);
  var dataType = EvmDataTypeFactory.getInstance().create(dataItem);
  return dataType;
}

exports.create = create;
/**
 * Convenience function to aggregate a single input or a set of inputs into a single DataItem.
 * An array of data items is grouped into a single tuple.
 * @param input A single data item; a set of data items; a signature.
 * @return A single data item corresponding to input.
 */

function consolidateDataItemsIntoSingle(input) {
  var dataItem;

  if (_.isArray(input)) {
    var dataItems = input;
    dataItem = {
      name: '',
      type: 'tuple',
      components: dataItems
    };
  } else {
    dataItem = _.isString(input) ? signature_parser_1.generateDataItemFromSignature(input) : input;
  }

  return dataItem;
}
/**
 * Convenience function for creating a Method encoder from different inputs.
 * @param methodName name of method.
 * @param input A single data item; a set of data items; a signature; or an array of signatures (optional).
 * @param output A single data item; a set of data items; a signature; or an array of signatures (optional).
 * @return Method corresponding to input.
 */


function createMethod(methodName, input, output) {
  var methodInput = input === undefined ? [] : consolidateDataItemsIntoArray(input);
  var methodOutput = output === undefined ? [] : consolidateDataItemsIntoArray(output);
  var methodAbi = {
    name: methodName,
    inputs: methodInput,
    outputs: methodOutput,
    type: 'function',
    // default fields not used by ABI
    constant: false,
    payable: false,
    stateMutability: 'nonpayable'
  };
  var dataType = new Method(methodAbi);
  return dataType;
}

exports.createMethod = createMethod;
/**
 * Convenience function that aggregates a single input or a set of inputs into an array of DataItems.
 * @param input A single data item; a set of data items; a signature; or an array of signatures.
 * @return Array of data items corresponding to input.
 */

function consolidateDataItemsIntoArray(input) {
  var dataItems;

  if (_.isArray(input) && _.isEmpty(input)) {
    dataItems = [];
  } else if (_.isArray(input) && _.isString(input[0])) {
    dataItems = [];

    _.each(input, function (signature) {
      var dataItem = signature_parser_1.generateDataItemFromSignature(signature);
      dataItems.push(dataItem);
    });
  } else if (_.isArray(input)) {
    dataItems = input;
  } else if (typeof input === 'string') {
    var dataItem = signature_parser_1.generateDataItemFromSignature(input);
    dataItems = [dataItem];
  } else {
    dataItems = [input];
  }

  return dataItems;
}
/* tslint:enable no-construct */